import React from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Faq from '../../components/faq';
import ReactTooltip from 'react-tooltip';
import PricingSchedule from '../../components/pricing-schedule';

export default class Pricing extends React.Component {
	render() {
		return (
			<div>
				<Helmet>
					<title>Rossware | Pricing</title>
					<meta name="fragment" content="!"></meta>
					<meta name="description" content="Rossware pricing - ServiceDesk pricing scales with your business. ServiceDesk addons are ala carte." />
					<meta property="og:title" content="Pricing - Rossware Software, LLC." />
					<meta property="og:image" href="%PUBLIC_URL%/logo512.png" />
				</Helmet>
				<ReactTooltip />
				<section className="pt-lg-6 pt-md-4">
					<div className="container-md">
						<div className="pre-text">Pricing</div>
						<h1 className="mb-0">Get the tools your company needs.</h1>
						<h1 className="mb-3">Flexible for any team size.</h1>
						<p className="mb-4">Core ServiceDesk software is available at a flat monthly rate.</p>
					</div>
					<div className="container-md mt-4">
						<div className="card pricing-card mb-5">
							<div className="card-body">
								<div className="grid-2-col">
									<div className="pricing-card-body">
										<div className="h2">Core software</div>
										<div>Unlimited access to the core features of our software, ServiceDesk.</div>
										<div className="">
											<div className="h2 mb-0">$199</div>
											<div className="small text-muted mb-1">Price in USD per month</div>
											<Link to="/contact" className="d-block btn btn-primary">Contact Sales</Link>
										</div>
									</div>
									<div className="plan-checklist-box">
										<div className="flex-list">
											<div className="flex-list-item"><div className="circle-check"></div>Call management</div>
											<div className="flex-list-item"><div className="circle-check"></div>Job management</div>
											<div className="flex-list-item"><div className="circle-check"></div>Scheduling and dispatch</div>
											<div className="flex-list-item"><div className="circle-check"></div>Inventory management</div>
											<div className="flex-list-item"><div className="circle-check"></div>Reporting</div>
											<div className="flex-list-item"><div className="circle-check"></div>Estimates and invoicing</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<PricingSchedule />
				</section>
				<Faq />


			</div>
		)
	}
}
